import { createSelector } from '@reduxjs/toolkit';
import { adapter, OrdersState, type } from './state';
import { selectedIdSelector as customerSelectedIdSelector } from '../customers/selectors';

const { selectAll } = adapter.getSelectors();

const featureStateSelector = (state: { [type]: OrdersState }) => state[type];

export const isFetchingOrdersSelector = createSelector(
    featureStateSelector,
    state => state.isFetching
);

export const errorMessageSelector = createSelector(
    featureStateSelector,
    state => state.errorMessage
);

export const ordersSelector = createSelector(
    featureStateSelector,
    selectAll
);

export const ordersByActiveCustomerSelector = createSelector(
    [ordersSelector, customerSelectedIdSelector],
    (orders, customerId) =>
        orders
            ? orders.filter(order => order.customerId === customerId).sort((a, b) => b.createdAt - a.createdAt)
            : orders
);

export const orderByUuidSelectorFactory = (uuid: string) =>
    createSelector(
        ordersSelector,
        (orders) => orders.find(o => o.uuid === uuid) ?? null
    );
